import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4f95f38a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=4f95f38a&lang=scss&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=4f95f38a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95f38a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f95f38a')) {
      api.createRecord('4f95f38a', component.options)
    } else {
      api.reload('4f95f38a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4f95f38a&scoped=true", function () {
      api.rerender('4f95f38a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Topbar/main.vue"
export default component.exports